import { render, staticRenderFns } from "./EmoticonPlusOutline.vue?vue&type=template&id=df882e4c"
import script from "./EmoticonPlusOutline.vue?vue&type=script&lang=js"
export * from "./EmoticonPlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports